<template>
  <view-wrapper name="Printers" :loading="loading" :loadingText="loadingText">
    <router-link class="mt-3 mb-10 button big primary white" to="addprinter"
      >Create new printer</router-link
    >

    <grafokett-button class="mt-3 mb-10 small" @click="refreshPrinters"
      >Refresh</grafokett-button
    >

    <FeatureZone features="pdfOnly">
      <modal type="warning" @close="$router.push(`/`)">
        <template slot="body">
          <h3>This is a PDF only tenant</h3>
          <p>
            The printers section has no effect on the system at the moment, contact
            support for info
          </p>
        </template>
      </modal>
    </FeatureZone>

    <expandabel-table
      :text="'Printers'"
      :headers="headersUsers"
      :data="installedPrinters"
      @searchQuery="searchText = $event"
    >
      <template v-slot:child="{ child }">
        <div class="flex">
          <div class="flex-1">
            <p class="ml-3">IP-adress: {{ child.ip }}</p>
            <p class="ml-3">Port: {{ child.port }}</p>

            <p v-if="child.groups.length > 0" class="mt-5 ml-3">
              Group belongings
            </p>
            <div class="rounded bg-primary-light">
              <div
                class="p-4 border-0 border-solid border-gray"
                :class="index !== 0 ? 'border-t' : ''"
                v-for="(g, index) in child.groups"
                :key="'var' + index"
              >
                <span>{{ g.name }}</span>
              </div>
            </div>
          </div>
          <div>
            <router-link
              :to="{ name: 'editprinter', params: { id: child.parentId } }"
              class="button small"
              >Edit <i style="font-size: 2em" class="edit-symbol"
            /></router-link>
          </div>
        </div>
      </template>
    </expandabel-table>
  </view-wrapper>
</template>

<script>
import ExpandabelTable from "../components/ExpandabelTable";
import Modal from "../components/Modal";
import FeatureZone from "../components/FeatureZone";
import GrafokettButton from "../components/forms/Button.vue";

export default {
  components: {
    ExpandabelTable,
    Modal,
    FeatureZone,
    GrafokettButton
  },
  data() {
    return {
      headersUsers: {
        name: "Name",
        vendor: "Vendor",
        model: "Model"
      },
      loading: false,
      loadingText: "List of printers",
      searchText: ""
    };
  },
  methods: {
    async getData() {
      await this.$store.dispatch("PRINTERS/GET_INSTALLED_PRINTERS");
      await this.$store.dispatch("PRINTERS/GET_VENDORS");
    },
    async refreshPrinters() {
      this.loading = true;
      await this.getData();
      this.loading = false;
    },
    searchResult(key) {
      return key.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
    }
  },
  computed: {
    installedPrinters() {
      return this.$store.getters["PRINTERS/INSTALLED_PRINTERS"]
        .map(p => {
          return {
            id: p.id,
            name: p.name,
            ip: p.ipAddress,
            port: p.port,
            model: p.model,
            vendor: p.vendor,
            expandableData: {
              ip: p.ipAddress,
              port: p.port,
              groups: p.groups
            }
          };
        })
        .filter(
          x =>
            this.searchResult(x.name) ||
            this.searchResult(x.ip) ||
            this.searchResult(x.model) ||
            this.searchResult(x.vendor)
        );
    },
    vendors() {
      return this.$store.getters["PRINTERS/VENDORS"].map(v => {
        return {
          name: v
        };
      });
    }
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  }
};
</script>

<style lang="postcss">
.printer-view {
  @apply m-8;
}
</style>
